<template>
    <nav class="primary-color-light">
        <div class="nav-wrapper">
            <ul class="left">
                <li v-if="selecionado"><a id="btn-voltar" href="#!" @click.prevent="voltar"><i class="material-icons">arrow_back</i></a></li>
                <router-link v-else tag="li" :to="uri"><a><i class="material-icons">{{icon}}</i></a></router-link>
            </ul>
            <a href="#" class="brand-logo">
                <div class="hide-on-small-only">{{title}} <span class="ultra-small grey-text"> {{ unit}}</span></div>
                <div class="hide-on-med-and-up"><h5 class="left-align" style="margin:5px 0;">{{title}}<br><span class="ultra-small grey-text">{{unit}}</span></h5></div>
            </a>

            <template v-if="usuaRole && ['REPRESENTANTE', 'PREPOSTO_REPRESE', 'VENDEDOR_EXTERNO', 'VENDEDOR_INTERNO'].includes(usuaRole)">
                <ul class="right hide-on-small-only">

                    <!--Chips de seleção do cliente-->
                    <li v-if="clienteSelecionado">
                        <a @click.prevent="limpaClienteSelecionado" class="waves-effect waves-light btn">
                            Cliente: {{clienteSelecionado.clieNome | firstName}}
                            <i class="material-icons right">close</i>
                        </a>
                    </li>
                </ul>
                
                <div class="row"></div>
            </template>
        </div>
    </nav>
</template>
<script>
export default {
    name:'nev-bar',
    props: {
        selecionado:{type:Boolean, required:false, default:false},
        uri:{type:String, required:true},
        icon:{type:String, required:false, default:'home'},
        title:{type:String, required:true},
        unit:{type:String, required:true},
        clienteSelecionado:{type:Object, default:null},
        usuaRole:{type:String, required:null},
    },
    methods:{
        voltar() {
            this.$emit('voltar');
        },
        limpaClienteSelecionado() {
            this.$emit('limpaClienteSelecionado');
		},
    },
}
</script>


// WEBPACK FOOTER //
// Navbar.vue?5e87d46a